import * as React from "react";
const SvgFiRrFolderOpen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-folder-open_svg__a)">
      <path
        fill="#062147"
        d="M23.493 11.017a2.53 2.53 0 0 0-2.05-1.03H21V8c0-2.757-2.243-5-5-5h-5.056c-.154 0-.31-.037-.447-.105L7.342 1.317A3 3 0 0 0 6 1.001H4A4.003 4.003 0 0 0 0 5v13c0 2.757 2.243 5 5 5h12.558c2.226 0 4.15-1.432 4.802-3.607l1.532-6.116a2.54 2.54 0 0 0-.399-2.26M2 18V5c0-1.103.897-2 2-2h2c.154 0 .31.037.447.105l3.155 1.578c.414.207.878.316 1.342.316H16c1.654 0 3 1.346 3 3v1.987H8.615a4.015 4.015 0 0 0-3.789 2.72l-2.19 7.138A3 3 0 0 1 2 18m19.964-5.253-1.532 6.115A2.98 2.98 0 0 1 17.558 21H5q-.312 0-.607-.062l2.334-7.609a2 2 0 0 1 1.889-1.342h12.828c.242 0 .383.14.445.224s.156.259.075.536"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-folder-open_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFolderOpen;
